import { PropTypes } from "prop-types";

const Logo = ({ customSource, type, href, ...props }) => {
  // types: [dark, grayscale, light, old-dark-old-light-1, old-light, white,]
  const getLogoSource = (type) => {
    return customSource || `/static/logo-${type}.svg`
  };

  return (
    <a href={href}>
      <img alt="Logo" src={getLogoSource(type)} {...props} />
    </a>
  )
};

Logo.propTypes = {
  type: PropTypes.string,
  height: PropTypes.number,
};

Logo.defaultProps = {
  type: "dark",
  height: 40,
};

export default Logo;
